export default "__VITE_ASSET__DTXDFnaf__"